import React from "react";
const ActivityTypesFilter = (props) => {
    const { name, value, onChange, availableActivities } = props;
    const onCheckboxClick = (event) => {
        const exerciseType = event.target.value;
        onChange(!event.target.checked
            ? value.filter((m) => m !== exerciseType)
            : [...value, exerciseType]);
    };
    const renderExerciseTypes = () => {
        return availableActivities.map((type) => (React.createElement("div", { className: "form-check w-50", key: type.alias },
            React.createElement("input", { className: "form-check-input", type: "checkbox", name: name, id: type.alias, value: type.alias, onChange: onCheckboxClick, checked: value.includes(type.alias) }),
            React.createElement("label", { className: "form-check-label m-0", htmlFor: type.alias }, type.name))));
    };
    return React.createElement("div", { className: "d-flex flex-wrap" }, renderExerciseTypes());
};
export default ActivityTypesFilter;
